module.exports = __webpack_public_path__ + "ca5f744dd89cf700b4dca5f48a390bbc.pdf";